import { filesApprovalStatusOptions, statusFilterOptions } from '../BookedMediaStatusFilter/options'

export const fileStatusFilterOptions = [...statusFilterOptions, ...filesApprovalStatusOptions]
  // sort it by label alphabetically
  .sort((a, b) => a.label.localeCompare(b.label))
